import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchRideCustomChargeRecords = async (requestIds: string[]) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      requestIds,
    },
    query: graphql(`
      query RideCustomChargeRecords($requestIds: [String!]!) {
        rideCustomChargeRecords(requestIds: $requestIds) {
          id
          associatedObjectId
          associatedObjectType
          currency
          description
          notes
          callerId
          customerName
          customerCost
          customerChargeId
          timeCustomerCharged
          customerRefund
          customerRefundId
          timeCustomerRefunded
          customerCredits
          timeCustomerCreditsUsed
          customerCreditsRefund
          timeCustomerCreditsRefunded
          partnerId
          partnerName
          partnerCost
          partnerChargeId
          timePartnerCharged
          partnerRefund
          partnerRefundId
          timePartnerRefunded
          partnerCredits
          timePartnerCreditsUsed
          partnerCreditsRefund
          timePartnerCreditsRefunded
        }
      }
    `),
  });

  return response.data.rideCustomChargeRecords;
};
